  import React, { useState,useEffect } from 'react';
import BoxWrapper from '../../components/ui/boxWrapper';
import AddIcon from '@mui/icons-material/Add';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import viewImage from './view.png';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import axios from "../../axios-order"
import { Snackbar, SnackbarContent } from '@mui/material';
import Box from '@mui/material/Box';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import GetAppIcon from "@material-ui/icons/GetApp";
import PublishIcon from "@material-ui/icons/Publish";
import RefreshIcon from '@mui/icons-material/Refresh';
import Button from '@mui/material/Button';
import {  Input } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { Delete } from '@mui/icons-material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Reciepent from "./excel/RecipientMaster.xlsx"
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Paper,TablePagination,  FormHelperText} from '@mui/material';
import ToggleSwitch from '../../components/ui/ToggleSwitch/ToggleSwitch';
import ProductMaster from './productmaster';

const apiUrl = process.env.REACT_APP_BACKEND_BASE_URL;

function CreateMaster({ handleClose }) {
  const [formValues, setFormValues] = useState({
    id:null,
    gstin: '',
    trade_name: '',
    address_two: '',
    phone: '',
    legal_name: '',
    address_one: '',
    location: '',
    pincode: '',
    email: '',
    state: '',
    mastertype:''
  });

  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0); 
  const [fieldErrors, setFieldErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [gstImage, setGstImage] = useState(null);
  const [gstImagePreview, setGstImagePreview] = useState(null);
  const [panImage, setPanImage] = useState(null);
  const [panPreview, setPanPreview] = useState(null);
  const [otherImage, setOtherImage] = useState(null);
  const [otherPreview, setOtherPreview] = useState(null);
  const [file, setFile] = useState(null);
  const [uploadHistory, setUploadHistory] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const [records, setRecords] = useState([]);
  const [isUploading, setIsUploading] = useState(false); 
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [errorSnackbar, setErrorSnackbar] = useState({ open: false, message: '' });
  const [summaryData, setSummaryData] = useState(null);
  const [isBoxVisible, setBoxVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('')
  const [errorMessage,setErrorMessage] = useState('')
  const [responseData, setResponseData] = useState(null);
  const [page, setPage] = useState(0);
  const [showUploadHistoryTable, setShowUploadHistoryTable] = useState(false);
  const [ReciepentMaster, setReciepentMaster] = useState(false);
const [rowsPerPage, setRowsPerPage] = useState(25); // Default to 25 rows per page
const [editedRowId, setEditedRowId] = useState(null);
const [highlightedCell, setHighlightedCell] = useState({ rowId: null, cellKey: null });
const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [snackbarSeverity, setSnackbarSeverity] = useState('success');
 const [currentRowId, setCurrentRowId] = useState(null);
const [isDialogOpenline, setDialogOpenline] = useState(false); 
  const [validationErrors,setValidationErrors] = useState([]);
    const [supplierChildData, setSupplierChildData] = useState([]);
const [formData, setFormData] = useState({
  gstin: '',
  location: '',
  pincode: '',
  address1: '',
  address2: '',
  state: '',
});
const [isEditMode, setIsEditMode] = useState(false);
const handlelineInputChange = (event) => {
  const { name, value } = event.target;
  console.log("name",name);
  console.log("value",value);
  setFormData((prevData) => ({
    ...prevData,
    [name]: value,
  }));
};

const handleAdd = (id) => {
  const selectedRow = rows.find((row) => row.id === id);
  if (selectedRow) {
    setFormData({
      gstin: selectedRow.recipient_gstin || '',
    });
  }
  setDialogOpenline(true);  
  setCurrentRowId(id); 
  axios.get(`/einvoice/get_recipient_child/${id}/`)
  .then(response =>{
    if (response.data && response.data.records) {
      setSupplierChildData(response.data.records); 
    }
  })
  .catch(error => {
    console.log(error)
  })

};

const handlelineClose = () => {
  setFormData({
    gstin: '',
    location: '',
    pincode: '',
    address1: '',
    address2: '',
    state: '',
  });
  setValidationErrors([]);
  setSupplierChildData([])
  setDialogOpenline(false);  
};

const handleEditline = (row) => {
  const matchedState = stateschild.find(
    (state) => state.name.toLowerCase().trim() === row.recipient_detail_state.toLowerCase().trim()
  );
  setFormData({
  
    location: row.recipient_detail_location || '',
    pincode: row.recipient_detail_pincode || '',
    address1: row.recipient_detail_address_one || '',
    address2: row.recipient_detail_address_two || '',
    state: matchedState ? matchedState.name : '',
  });
  setCurrentRowId(row.id);
  setIsEditMode(true);
};

const handleSubmitline = (id) => {
  const requiredFields = ['location', 'pincode', 'address1', 'state'];
  const missingFields = requiredFields.filter((field) => !formData[field]);

  if (missingFields.length > 0) {
    setValidationErrors(missingFields);
    return;
  }
  const payload = {
    recipient_master_id: id,
    // gstin: formData.gstin,
    recipient_location: formData.location,
    recipient_pincode: formData.pincode,
    recipient_address_one: formData.address1,
    recipient_address_two : formData.address2,
    recipient_state: formData.state,
  };
  if (isEditMode) {
   
    payload.id = currentRowId;
  }

  const url = isEditMode ? '/einvoice/update_recipient_child' : '/einvoice/post_recipient_additional_address';

  axios.post(url, payload)
    .then((response) => {
      console.log(response);
      if (response?.data?.message) {
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: 'success'
        });
      }

      refresh();
      setDialogOpenline(false); 
      setIsEditMode(false);
      
    })
    .catch((error) => {
      console.log(error);
      setErrorSnackbar({
        open: true,
        message: error.response?.data?.message,
        severity: 'error'
      });
    });
};

  
  

 
  const handleFileChange = async (event) => {
    
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile); 
  
    
      if (isUploading) {
        return;
      }
  
    
      setLoading(true);
      setIsUploading(true);
  
      const businessEntityId = localStorage.getItem('business_entity_id');
      const user = localStorage.getItem('user_id');
  
      if (!businessEntityId) {
       
        setLoading(false);
        setIsUploading(false);
        return;
      }
  
      if (!selectedFile) {
    
        setLoading(false);
        setIsUploading(false);
        setSnackbar({ open: true, message: 'Please select a file first.', severity: 'error' });
        return;
      }
  
      try {
       
        const base64File = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64String = `data:${selectedFile.type};base64,${btoa(reader.result)}`;
            resolve(base64String);
          };
          reader.onerror = reject;
          reader.readAsBinaryString(selectedFile);
        });
  

        await axios.post('/einvoice/import_recipient_master', {
          business_entity_id: businessEntityId,
          user: user,
          file: base64File, 
        });
  
        setSnackbar({ open: true, message: 'File uploaded successfully.', severity: 'success' });
  
        const formNumber = '100'; 
        const response = await axios.get(`/einvoice/get_data_upload_history/${businessEntityId}/${formNumber}`);
  
       
        setUploadHistory(response.data.record); 
  
        setTimeout(() => {
       
          refresh();
        }, 1000);
  
      } catch (error) {
        console.error('Error uploading file or retrieving history:', error);
      } finally {
     
        setLoading(false);
        setIsUploading(false);
        
      event.target.value = null;
      }
    }
  };
  
  const stateschild = [
    { code: 'AP', name: 'Andhra Pradesh' },
    { code: 'AR', name: 'Arunachal Pradesh' },
    { code: 'AS', name: 'Assam' },
    { code: 'BR', name: 'Bihar' },
    { code: 'CT', name: 'Chhattisgarh' },
    { code: 'GA', name: 'Goa' },
    { code: 'GJ', name: 'Gujarat' },
    { code: 'HR', name: 'Haryana' },
    { code: 'HP', name: 'Himachal Pradesh' },
    { code: 'JH', name: 'Jharkhand' },
    { code: 'KA', name: 'Karnataka' },
    { code: 'KL', name: 'Kerala' },
    { code: 'MP', name: 'Madhya Pradesh' },
    { code: 'MH', name: 'Maharashtra' },
    { code: 'MN', name: 'Manipur' },
    { code: 'ML', name: 'Meghalaya' },
    { code: 'MZ', name: 'Mizoram' },
    { code: 'NL', name: 'Nagaland' },
    { code: 'OR', name: 'Odisha' },
    { code: 'PB', name: 'Punjab' },
    { code: 'RJ', name: 'Rajasthan' },
    { code: 'SK', name: 'Sikkim' },
    { code: 'TN', name: 'Tamil Nadu' },
    { code: 'TG', name: 'Telangana' },
    { code: 'TR', name: 'Tripura' },
    { code: 'UP', name: 'Uttar Pradesh' },
    { code: 'UT', name: 'Uttarakhand' },
    { code: 'WB', name: 'West Bengal' },
    { code: 'AN', name: 'Andaman and Nicobar Islands' },
    { code: 'CH', name: 'Chandigarh' },
    { code: 'DH', name: 'Dadra and Nagar Haveli and Daman and Diu' },
    { code: 'DL', name: 'Delhi' },
    { code: 'JK', name: 'Jammu and Kashmir' },
    { code: 'LA', name: 'Ladakh' },
    { code: 'LD', name: 'Lakshadweep' },
    { code: 'PY', name: 'Puducherry' },
    { code: 'NT', name: 'Other Territory' },
    { code: 'OC', name: 'Other Country' }
  ];

 
  

  // List of Indian states
  const states = [
    { code: 'AP', name: 'Andhra Pradesh' },
    { code: 'AR', name: 'Arunachal Pradesh' },
    { code: 'AS', name: 'Assam' },
    { code: 'BR', name: 'Bihar' },
    { code: 'CG', name: 'Chhattisgarh' },
    { code: 'GO', name: 'Goa' },
    { code: 'GJ', name: 'Gujarat' },
    { code: 'HR', name: 'Haryana' },
    { code: 'HP', name: 'Himachal Pradesh' },
    { code: 'JH', name: 'Jharkhand' },
    { code: 'KA', name: 'Karnataka' },
    { code: 'KL', name: 'Kerala' },
    { code: 'MP', name: 'Madhya Pradesh' },
    { code: 'MH', name: 'Maharashtra' },
    { code: 'MN', name: 'Manipur' },
    { code: 'ME', name: 'Meghalaya' },
    { code: 'MI', name: 'Mizoram' },
    { code: 'NL', name: 'Nagaland' },
    { code: 'OD', name: 'Odisha' },
    { code: 'PB', name: 'Punjab' },
    { code: 'RJ', name: 'Rajasthan' },
    { code: 'SK', name: 'Sikkim' },
    { code: 'TN', name: 'Tamil Nadu' },
    { code: 'TS', name: 'Telangana' },
    { code: 'TR', name: 'Tripura' },
    { code: 'UP', name: 'Uttar Pradesh' },
    { code: 'UT', name: 'Uttarakhand' },
    { code: 'WB', name: 'West Bengal' },
    { code: 'DL', name: 'Delhi' },
    { code: 'LD', name: 'Lakshadweep' },
    { code: 'PY', name: 'Puducherry' },
    { code: 'AN', name: 'Andaman and Nicobar Islands' },
    { code: 'CH', name: 'Chandigarh' },
    { code: 'DD', name: 'Dadra and Nagar Haveli and Daman and Diu' },
    { code: 'LA', name: 'Ladakh' },
    { code: 'JK', name: 'Jammu and Kashmir' },
    { code: 'OT', name: 'Other Territory' },
    { code: 'OC', name: 'Other Country' },
  ];

  const mastertype = [
    { code: 'CUSTOMER', name: 'CUSTOMER ' },
    { code: 'VENDOR', name: 'VENDOR' },
  ]

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };


  const handleInputgstChange = (e) => {
    const { name, value } = e.target;
  
  
  const upperCaseValue = value.toUpperCase();
  const gstinPattern = /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}[A-Za-z][0-9A-Za-z]{1}$/;
  if (/^[A-Za-z0-9]*$/.test(upperCaseValue) && upperCaseValue.length <= 15) {
    setFormValues({
      ...formValues,
      [name]: upperCaseValue,
    });
    if (upperCaseValue.length === 15 && !gstinPattern.test(upperCaseValue)) {
      setFieldErrors((prevErrors) => ({
        ...prevErrors,
        gstin: 'Invalid GSTIN',
      }));
    } else {
      setFieldErrors((prevErrors) => ({
        ...prevErrors,
        gstin: '',  
      }));
    }
  }
  };

  const handlePhoneChange = (e) => {
    const { name, value } = e.target;
   
    if (/^\d{0,10}$/.test(value)) {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };
  

  const handlePinChange = (e) => {
    const { name, value } = e.target;
    
    
    if (/^\d{0,6}$/.test(value)) {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };
  

  const handleInputsupplierChange = (e) => {
    const { name, value } = e.target;
  
   if (/^[A-Za-z0-9\s!@#$%^&*(),.?"':{}|<>\\/\-]*$/.test(value)) {
    setFormValues({
      ...formValues,
      [name]: value,
    });
  }
  };


  const handleInputlocationChange = (e) => {
    const { name, value } = e.target;
  
    
    if (/^[A-Za-z\s]*$/.test(value)) {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };
  const handleClear = () => {
    setFormValues({
      gstin: '',
      trade_name: '',
      address_two: '',
      phone: '',
      legal_name: '',
      address_one: '',
      location: '',
      pincode: '',
      email: '',
      state: '', 
      mastertype:''
    });
    
  
  };
 

  const handleFileUpload = (e, setImage, setPreview) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
        

    if (file.size > 1 * 1024 * 1024) {
      setSnackbarMessage('File size exceeds 1MB. Please upload a smaller file.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true); 
      return; 
    }

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setImage(base64String); 
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      // alert('Please upload a valid image file.');
    }
  };
  

  const handleRemoveImage = (setImage, setPreview) => {
    setImage(null);
    setPreview(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const businessEntityId = localStorage.getItem('business_entity_id');
    const mandatoryFields = [
      { name: 'gstin', message: 'GSTIN is required' },
      { name: 'trade_name', message: 'Trade Name is required' },
      { name: 'legal_name', message: 'Legal Name is required' },
      { name: 'address_one', message: 'Address 1 is required' },
      { name: 'location', message: 'Location is required' },
      { name: 'pincode', message: 'Pin Code is required' },
      { name: 'state', message: 'State is required' },
      { name: 'mastertype', message: 'Master Type is required' }
     
    ];
    const newFieldErrors = {};
  
 
      if (formValues.phone && formValues.phone.length !== 10) {
    setSnackbar({
        open: true,
         message: 'Please enter a 10-digit phone number',
        severity: 'error'
      });
      return;
   }

  
   if (formValues.pincode && formValues.pincode.length !== 6) {
    setSnackbar({
      open: true,
      message: 'Pin code must be  6 digits',
      severity: 'error'
   });
    return;
 }
  
    const missingFields = mandatoryFields.filter(field => !formValues[field]);
  
 
    mandatoryFields.forEach(field => {
      if (!formValues[field.name]) {
        newFieldErrors[field.name] = field.message;
      }
    });

    if (Object.keys(newFieldErrors).length > 0) {
      setFieldErrors(newFieldErrors);
      setSnackbar({
        open: true,
        message: 'Please fill all mandatory fields',
        severity: 'error'
      });
      return;
    }

    try {
      const response = await axios.post('/einvoice/post_recipient_master', {
        ...formValues,
        id: formValues.id ?? null,
        business_entity_id: businessEntityId,
        gst_attachment: gstImage || '', 
        pan_attachment: panImage || '',  
        other_attachment: otherImage || '',  
      });
  

     
    
     if (response.data.status) {
  setSnackbar({
    open: true,
    message: response.data.message,
    severity: 'success', 
  });
  setHighlightedCell({ rowId: formValues.id, cellKey: 'trade_name' }); 
  setTimeout(() => {
    setHighlightedCell({ rowId: null, cellKey: null });
  }, 7000);
  handleToggle({ target: { checked: false } });
}
 // Clear all fields
 setFormValues({
  gstin: '',
  trade_name: '',
  address_two: '',
  phone: '',
  legal_name: '',
  address_one: '',
  location: '',
  pincode: '',
  email: '',
  state: '',
  mastertype:''
});

setFieldErrors({});
    refresh();
      handleClose();
      
    } catch (error) {
      console.error('Error:', error); 
     

      setErrorSnackbar({
        open: true,
        message: error.response?.data?.message || 'Internal Server Error.',
      });
    }
  };
  
  
  
  
  
  
  
  



const handleDownloadTemplate = () => {
  
  const link = document.createElement('a');
  link.href = Reciepent;
  link.download = 'RecipientMaster.xlsx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);



};

const handleCloseBox = () => {
  setBoxVisible(false); 
};

const handleExportExcel = () => {
  const bid = localStorage.getItem('business_entity_id');
  const fileName = 'Recipients'; 

  if (bid) {
    const url = `/einvoice/export_recipient_master/${fileName}/${bid}`;

    axios.get(url)
      .then(response => { 
       
        const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const base64Data = response.data.file;
        downloadBase64File(contentType, base64Data, `${fileName}.xlsx`);
      })
      .catch(error => {
        console.error("Error exporting file:", error);
      });
  } else {
    console.error('Business entity ID not found in localStorage');
  }
};


const handleExcel = async () => {
  const businessEntityIdRaw = localStorage.getItem('business_entity_id');

  if (!businessEntityIdRaw) {
    console.error('Business entity ID is missing');
    return;
  }

  try {
   
    if (!responseData) {
      console.error('Response data is missing');
      return;
    }

    const payloadData = {
      'business_entity_id': businessEntityIdRaw,
      'data': responseData
    };

   

   
    const response = await axios.post(`/einvoice/download_error_data`, payloadData);



  
    const base64Data = response.data.file; 
    if (base64Data) {
      const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const filename = 'RecipientUploadErrorLogs.xlsx';
      downloadBase64File(contentType, base64Data, filename);
    } else {
      console.error('Base64 data not found in the response');
    }

  } catch (error) {
   
    console.error('Error fetching Excel file:', error);
  }
};






const downloadBase64File = (contentType, base64Data, fileName) => {
  const linkSource = `data:${contentType};base64,${base64Data}`;
  const downloadLink = document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};







const refresh = async (pageNumber = 0, rowsPerPage = 25, searchTxt = '') => {

  const businessEntityId = localStorage.getItem('business_entity_id');
  const formNumber = '100';

  try {
 
  
     const postResponse = await axios.post('/einvoice/upload_recipient', {
      number_of_rows_per_page: rowsPerPage,
      page_number: pageNumber,
      business_entity_id: businessEntityId,
      search_txt: searchTxt,
    });

   
    setRowCount(postResponse.data.row_count);
    if (postResponse.data.records) {
      setRows(postResponse.data.records);  
    }

       
       const response = await axios.get(`/einvoice/get_data_upload_history/${businessEntityId}/${formNumber}`);

       
       setUploadHistory(response.data.record); 
       setRefreshTrigger(prev => !prev); 
  } catch (error) {
    console.error('Error refreshing data:', error);
 
  }
};
 
useEffect(() => {
  refresh(page, rowsPerPage, searchTerm);
}, [page, rowsPerPage, searchTerm]); 


const searchInputOnchange = async (event) => {
  const value = event.target.value;
  setSearchText(value);
  await refresh(value); 
};






const handleSearchChange = (event) => {
  const newSearchTerm = event.target.value;
  setSearchTerm(newSearchTerm);
  refresh(page, rowsPerPage, newSearchTerm); 
};


const filteredRows = Array.isArray(rows)
  ? rows.filter(row => Object.values(row).some(value => typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())))
  : [];

  const handleEyeIconClick = async (id) => {
    try {
      const response = await axios.get(`/einvoice/get_data_upload_json/${id}`);
      const { data } = response;
         
             
    setResponseData(data);
    
      if (data && data.records && data.records.records && data.records.records.summary) {
        setBoxVisible(true);
        setSummaryData(data.records.records.summary);
      }

      if (data && data.records && data.records.message) {
      
        if (!data.records.status) { 
          setErrorMessage(data.records.message);
          setSnackbar({ open: true, message: data.records.message, severity: 'error' });
          handleCloseBox();
        } else {
          setErrorMessage('');
        }
      }
      
      
      if (data && data.records && data.records.message) {
      
        if (data.records.status) {
          // setSnackbar({ open: true, message: data.records.message, severity: 'error' });
        } else {
          // setSnackbar({ open: true, message: data.records.message, severity: 'error' });
        }
      }
      setDialogData(data.records.records);
    
    
        
    } catch (error) {
      console.error('Error fetching data:', error);
      setSnackbar({ open: true, message: 'Failed to fetch data', severity: 'error' });
    }
  };

  const cardStyle1 = {
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: '#6f9eaf',
    textAlign: 'left', 
    width: '300px',
    height: '70px',
    color: 'white',
    fontSize: '20px',
    padding: '10px', 
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start', 
    alignItems: 'flex-start'
  
  };
  
  const cardStyle2 = {
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: '#007965',
    textAlign: 'left', 
    width: '300px',
    height: '70px', 
    color: 'white',
    fontSize: '20px',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start' 
  };
  
  
  const cardStyle3 = {
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: '#eb596e',
    textAlign: 'left', 
    width: '300px',
    height: '70px',
    color: 'white',
    fontSize: '20px',
    padding: '10px', 
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start', 
    alignItems: 'flex-start' 
  };
  

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDialogData(null);
  };

 const handleEdit = (row) => {
  handleToggle({ target: { checked: true } });

 

    window.scrollTo({
      top: window.pageYOffset - 580,
      behavior: 'smooth'
    });
  setFormValues({
    id:row.id || '',
    gstin: row.recipient_gstin || '',
    trade_name: row.recipient_trade_name || '',
    address_two: row.recipient_address_two || '',
    phone: row.recipient_phone || '',
    legal_name: row.recipient_legal_name || '',
    address_one: row.recipient_address_one || '',
    location: row.recipient_location || '',
    pincode: row.recipient_pincode || '',
    email: row.recipient_email || '',
    state: row.recipient_state || '',
    mastertype: row.recipient_master_type || ''
  });
  setEditedRowId(row.id);
  setTimeout(() => {
    setEditedRowId(null);
  }, 7000);
};


const handleToggleChange = () => {
  setShowUploadHistoryTable(!showUploadHistoryTable);
};
  
const handleToggle = (event) =>{
  setReciepentMaster(event.target.checked)
  if (!event.target.checked){
  setFormValues({
    id:null,
    gstin: '',
    trade_name: '',
    address_two: '',
    phone: '',
    legal_name: '',
    address_one: '',
    location: '',
    pincode: '',
    email: '',
    state: '',
    mastertype:''
  })
}
}

  
  

  return (
    <div>
       <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div>
        <ToggleSwitch
         id="toggleUploadRecipient"  
          onChange={handleToggleChange}
          value={showUploadHistoryTable}
          label="Upload Master"
         
        />
         <div className="container">
          <div>
            <input
              type="checkbox"
              className="toggle-switch"
              id="default1"
              onChange={handleToggle}
              checked={ReciepentMaster}
            />
            <label htmlFor="default1"></label>
          </div>
          <p> Add Master</p>
        </div>
      </div>
    </div>
    { showUploadHistoryTable &&  (
            <BoxWrapper boxTitle="Master Uploads"
            //  enableSearchInput={true}
              //  searchInputPlaceholder="Search..."
                //  searchInputOnchange={searchInputOnchange}
            >
         
         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
         <div  style={{ display: 'flex'}} >  
      <Button
       style={{ whiteSpace: 'nowrap' }}
        onClick={handleDownloadTemplate}
      >
          <GetAppIcon style={{ fontSize: "20px" }} />
        Download Template
      </Button>
      <Button component="label" size="small" color="primary" style={{ whiteSpace: 'nowrap' }}>
        <PublishIcon style={{ fontSize: "20px" }} />
       
        UPLOAD TEMPLATE
        <input
          accept=".xlsx"
          name="file"
          type="file"
          hidden
          onChange={handleFileChange} 
        />
      </Button>
     
      </div>
      <Button
  variant="contained"
  onClick={() => refresh()} 
  style={{ 
    marginTop: '10px', 
    marginLeft: '500px',
    backgroundColor: 'white',
    
    border: 'none',
    color: '#3e71c2', // To ensure text is visible on white background
    boxShadow: 'none', // Optional: Remove the box-shadow if desired
  }}
  startIcon={<RefreshIcon />}
>
  REFRESH
</Button>
</div>
      <TableContainer component={Paper} style={{ marginTop: '20px' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell  style={{ fontSize: '15px', fontWeight: 'bold' ,paddingLeft:'15px'}}>Upload Date</TableCell>
            
            <TableCell  style={{ fontSize: '15px', fontWeight: 'bold' ,paddingLeft:'15px' }}>Status</TableCell>
            <TableCell  style={{ fontSize: '15px', fontWeight: 'bold',paddingLeft:'15px' }}>Upload Type</TableCell>
            <TableCell style={{ fontSize: '15px', fontWeight: 'bold',paddingLeft:'15px' }}>Action</TableCell> 
            
          </TableRow>
        </TableHead>
        <TableBody>
          {uploadHistory.map((record) => (
            <TableRow key={record.id}>
              <TableCell style={{ padding: '3px',paddingLeft:'15px' }}>{record.upload_date}</TableCell>     
              <TableCell style={{ padding: '3px'  ,paddingLeft:'15px' }}>{record.status}</TableCell>    
              <TableCell style={{ padding: '3px',paddingLeft:'15px'  }}>{record.upload_type}</TableCell>
              <TableCell style={{ padding: '3px' ,paddingLeft:'15px'  }}>
                <IconButton onClick={() => handleEyeIconClick(record.id)}>
               
                  <img src={viewImage} alt="View" style={{ width: '24px', height: '24px' }} />
                </IconButton>
              </TableCell>
              
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    

    
      </BoxWrapper>
      )}

      {isBoxVisible && (
  <BoxWrapper 
  boxTitle="Uploads Details"
  exportToExcelEnable={true}
  exportToExcelFn={handleExcel} 
  cutIcon={true}  // This enables the close icon
  closeBoxWapper={handleCloseBox}  // This is the function that will be called when the close button is clicked
 
  >
    {/* {errorMessage && (
      <p style={{ color: 'red' }}>{errorMessage}</p>
    )} */}
    {  summaryData ? (
      <div>
        {/* Cards Section */}
        <div style={{ display: 'flex', gap: '20px' }}>
          <div style={cardStyle1}>
            <div>Total Records</div>
            <div>{summaryData.total_records}</div>
          </div>
          <div style={cardStyle2}>
            <div>Valid Records</div>
            <div>{summaryData.valid_records}</div>
          </div>
          <div style={cardStyle3}>
            <div>Invalid Records</div>
            <div>{summaryData.invalid_records}</div>
          </div>
        </div>

        {/* Table Section */}
        <div style={{ marginTop: '20px' }}> {/* This wrapper creates a new line for the table */}
        {summaryData.invalid_records !== 0 && (
  <TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>GSTIN</TableCell>
          <TableCell>INVOICE NUMBER</TableCell>
          <TableCell>ROW#</TableCell>
          <TableCell>ERRORS</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {dialogData && Array.isArray(dialogData.details) ? (
          dialogData.details.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{/* Replace with actual field */}</TableCell>
              <TableCell>{/* Replace with actual field */}</TableCell>
              <TableCell>{item.row}</TableCell>
              <TableCell>
                {item.errors_in ? (
                  Object.entries(item.errors_in).map(([field, errors], i) => (
                    <div key={i}>
                      {field}: {errors.join(', ')}
                    </div>
                  ))
                ) : ''}
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={4}>No data available</TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
)}
        </div>
      </div>
    ) : (
      <div>Loading...</div>
    )}
  </BoxWrapper>
  
)}
      <Snackbar open={errorSnackbar.open} 
      
      autoHideDuration={6000}
      sx={{ mt: 4 }}
  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
       onClose={() => setErrorSnackbar({ ...errorSnackbar, open: false })}>
      <Alert onClose={() => setErrorSnackbar({ ...errorSnackbar, open: false })}  variant="filled" severity="error">
        {errorSnackbar.message}
      </Alert>
    </Snackbar>
 {ReciepentMaster && (
      <BoxWrapper boxTitle="Master">
        <Box component="form" sx={{ mt: 3 }} onSubmit={handleSubmit}>
          <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!fieldErrors.mastertype} >
                <InputLabel id="master-label">Master Type*</InputLabel>
                <Select
               
                  labelId="mastertype-label"
                  id="mastertype"
                  name="mastertype"
                  value={formValues.mastertype}
                  onChange={handleInputChange}
                  label="Master Type*"
                >
                  {mastertype.map((master) => (
                    <MenuItem key={master.code} value={master.name}>
                      {master.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{fieldErrors.mastertype || ''}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
    
                fullWidth
                id="supplier-gstin"
                label="GSTIN*"
                name="gstin"
                value={formValues.gstin}
                onChange={handleInputgstChange}
                error={!!fieldErrors.gstin} 
        helperText={fieldErrors.gstin || ''} 
                
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
              
                fullWidth
                id="trade-name"
                label="Trade Name*"
                name="trade_name"
                value={formValues.trade_name}
                onChange={handleInputChange}
                error={!!fieldErrors.trade_name}
                helperText={fieldErrors.trade_name || ''}
              />
            </Grid>
           
            <Grid item xs={12} sm={6}>
              <TextField
           
                fullWidth
                id="legal-name"
                label="Legal Name*"
                name="legal_name"
                value={formValues.legal_name}
                onChange={handleInputChange}
                error={!!fieldErrors.legal_name}
                helperText={fieldErrors.legal_name || ''}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
               
                fullWidth
                id="supplier-address1"
                label="Master Address 1*"
                name="address_one"
                value={formValues.address_one}
                onChange={handleInputsupplierChange}
                error={!!fieldErrors.address_one}
                helperText={fieldErrors.address_one || ''}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                // required
                fullWidth
                id="supplier-address2"
                label="Master Address 2"
                name="address_two"
                value={formValues.address_two}
                onChange={handleInputsupplierChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
               
                fullWidth
                id="supplier-location"
                label="Master Location*"
                name="location"
                value={formValues.location}
                onChange={handleInputlocationChange}
                error={!!fieldErrors.location}
                helperText={fieldErrors.location || ''}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!fieldErrors.state} >
                <InputLabel id="state-label">State*</InputLabel>
                <Select
               
                  labelId="state-label"
                  id="state"
                  name="state"
          
                  value={formValues.state}
                  onChange={handleInputChange}
                  label="State*"
                >
                  {states.map((state) => (
                    <MenuItem key={state.code} value={state.name}>
                      {state.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{fieldErrors.state || ''}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
              
                fullWidth
                id="pin-code"
                label="Pin Code*"
                name="pincode"
                value={formValues.pincode}
                onChange={handlePinChange}
                error={!!fieldErrors.pincode}
                helperText={fieldErrors.pincode || ''}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
             
                fullWidth
                id="phone"
                label="Phone"
                name="phone"
                value={formValues.phone}
                onChange={handlePhoneChange}
                error={!!fieldErrors.phone}
                helperText={fieldErrors.phone || ''}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                // required
                fullWidth
                id="email-id"
                label="Email ID"
                name="email"
                type="email"
                value={formValues.email}
                onChange={handleInputChange}
              />
            </Grid>

            <Grid item xs={12}>
            <Grid item xs={12}>
        <Grid container spacing={2}>
          {/* GST Attachment */}
          <Grid item xs={4}>
            <input
              accept=".jpg,.jpeg,.png,.pdf"
              id="upload-gst-image"
              type="file"
              style={{ display: 'none' }}
              onChange={(e) => handleFileUpload(e, setGstImage, setGstImagePreview)}
            />
            <label htmlFor="upload-gst-image" style={{ fontSize: '16px', marginRight: '30px' }}>
              GST ATTACHMENT
            </label>
            <label htmlFor="upload-gst-image">
              <Button
                variant="outlined"
                color="secondary"
                component="span"
                sx={{
                  borderColor: 'green',
                  color: 'green',
                  textTransform: 'none',
                  '&:hover': {
                    borderColor: 'darkgreen',
                    color: 'darkgreen',
                  },
                }}
              >
                Upload
              </Button>
            </label>
            <Button
              variant="outlined"
              color="secondary"
              component="span"
              sx={{
                borderColor: 'red',
                color: 'red',
                textTransform: 'none',
                '&:hover': {
                  borderColor: 'red',
                  color: 'red',
                },
              }}
              onClick={() => handleRemoveImage(setGstImage, setGstImagePreview)}
              style={{ marginLeft: '20px' }}
            >
              Remove
            </Button>
            {gstImagePreview && (
              <div style={{ marginTop: '10px' }}>
                <img
                  src={gstImagePreview}
                  alt="GST Attachment"
                  style={{ maxWidth: '60%', maxHeight: '140px', border: '1px solid #ccc' }}
                />
              </div>
            )}
            <div style={{ fontSize: '10px', color: '#909499' }}>
              <p>Preferred Image Dimensions: 240*240 pixels @ 72 DPI</p>
              <p>Maximum File Size: 3MB</p>
              <p>Format - PDF, JPG, JPEG & PNG</p>
            </div>
          </Grid>

          {/* PAN Attachment */}
          <Grid item xs={4}>
            <input
              accept=".jpg,.jpeg,.png,.pdf"
              id="upload-pan-image"
              type="file"
              style={{ display: 'none' }}
              onChange={(e) => handleFileUpload(e, setPanImage, setPanPreview)}
            />
            <label htmlFor="upload-pan-image" style={{ fontSize: '16px', marginRight: '30px' }}>
              PAN ATTACHMENT
            </label>
            <label htmlFor="upload-pan-image">
              <Button
                variant="outlined"
                color="secondary"
                component="span"
                sx={{
                  borderColor: 'green',
                  color: 'green',
                  textTransform: 'none',
                  '&:hover': {
                    borderColor: 'darkgreen',
                    color: 'darkgreen',
                  },
                }}
              >
                Upload
              </Button>
            </label>
            <Button
              variant="outlined"
              color="secondary"
              component="span"
              sx={{
                borderColor: 'red',
                color: 'red',
                textTransform: 'none',
                '&:hover': {
                  borderColor: 'red',
                  color: 'red',
                },
              }}
              onClick={() => handleRemoveImage(setPanImage, setPanPreview)}
              style={{ marginLeft: '20px' }}
            >
              Remove
            </Button>
            {panPreview && (
              <div style={{ marginTop: '10px' }}>
                <img
                  src={panPreview}
                  alt="PAN Attachment"
                  style={{ maxWidth: '60%', maxHeight: '140px', border: '1px solid #ccc' }}
                />
              </div>
            )}
            <div style={{ fontSize: '10px', color: '#909499' }}>
              <p>Preferred Image Dimensions: 240*240 pixels @ 72 DPI</p>
              <p>Maximum File Size: 3MB</p>
              <p>Format - PDF, JPG, JPEG & PNG</p>
            </div>
          </Grid>

          {/* Other Attachment */}
          <Grid item xs={4}>
            <input
              accept=".jpg,.jpeg,.png,.pdf"
              id="upload-other-image"
              type="file"
              style={{ display: 'none' }}
              onChange={(e) => handleFileUpload(e, setOtherImage, setOtherPreview)}
            />
            <label htmlFor="upload-other-image" style={{ fontSize: '16px', marginRight: '30px' }}>
              OTHER ATTACHMENT
            </label>
            <label htmlFor="upload-other-image">
              <Button
                variant="outlined"
                color="secondary"
                component="span"
                sx={{
                  borderColor: 'green',
                  color: 'green',
                  textTransform: 'none',
                  '&:hover': {
                    borderColor: 'darkgreen',
                    color: 'darkgreen',
                  },
                }}
              >
                Upload
              </Button>
            </label>
            <Button
              variant="outlined"
              color="secondary"
              component="span"
              sx={{
                borderColor: 'red',
                color: 'red',
                textTransform: 'none',
                '&:hover': {
                  borderColor: 'red',
                  color: 'red',
                },
              }}
              onClick={() => handleRemoveImage(setOtherImage, setOtherPreview)}
              style={{ marginLeft: '20px' }}
            >
              Remove
            </Button>
            {otherPreview && (
              <div style={{ marginTop: '10px' }}>
                <img
                  src={otherPreview}
                  alt="Other Attachment"
                  style={{ maxWidth: '60%', maxHeight: '140px', border: '1px solid #ccc' }}
                />
              </div>
            )}
            <div style={{ fontSize: '10px', color: '#909499' }}>
              <p>Preferred Image Dimensions: 240*240 pixels @ 72 DPI</p>
              <p>Maximum File Size: 3MB</p>
              <p>Format - PDF, JPG, JPEG & PNG</p>
            </div>
          </Grid>
        </Grid>
      </Grid>
      </Grid>
    </Grid>
           

         
         
            <Grid item xs={12} display="flex" justifyContent="flex-start">
  <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
    <Button
      type="submit"
      variant="contained"
      color="primary"
      sx={{ width: 120 }}
    >
      Add
    </Button>
    <Button
      variant="outlined"
      color="secondary"
      onClick={handleClear}
    >
      Clear
    </Button>
  
  </Box>
  
</Grid>



   
       
          
        </Box>
      

      </BoxWrapper>
      )}
     
      <Snackbar
  open={snackbar.open}
  autoHideDuration={6000}
  onClose={() => setSnackbar({ ...snackbar, open: false })}
  sx={{ mt: 4 }}
  anchorOrigin={{ vertical: 'top', horizontal: 'right' }} 
>
  <Alert onClose={() => setSnackbar({ ...snackbar, open: false })}  variant="filled" severity={snackbar.severity} sx={{ width: '100%' }}>
    {snackbar.message}
  </Alert>
</Snackbar>

      <BoxWrapper  boxTitle="Master Details"
             enableSearchInput={true}
             searchInputPlaceholder="Search..."  
             searchInputOnchange={handleSearchChange}  
             exportToExcelEnable={true}
             exportToExcelFn={handleExportExcel} 
               >
      
      
    <div style={{ maxHeight: '400px', overflow: 'auto', scrollbarWidth: 'thin' }}>
  <Table sx={{ tableLayout: 'auto' }}>
    <TableHead>
      <TableRow>
        {[
          'GSTIN',
          'LEGAL NAME',
          'TRADE NAME',
          'ADDRESS 1',
          'ADDRESS 2',
          'LOCATION',
          'STATE',
          'PINCODE',
          'EMAIL',
          'PHONE',
          'ACTION',
        ].map((header) => (
          <TableCell
            key={header}
            style={{
              fontSize: '15px',
              fontWeight: 'bold',
              position: 'sticky',
              top: 0,
              backgroundColor: '#fff',
              zIndex: 1,
              padding: '8px 16px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {header}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
    <TableBody>
  {rows && rows.length > 0 ? (
    rows.map((row) => (
      <TableRow key={row.id}   style={{
        backgroundColor: editedRowId === row.id ? 'lightgreen' : 'transparent',
        transition: 'background-color 4s ease',
      }}
      >
        <TableCell style={{ padding: '8px 16px' }}>{row.recipient_gstin}</TableCell>
        <TableCell style={{ padding: '8px 16px' }}>{row.recipient_legal_name}</TableCell>
        <TableCell style={{ padding: '8px 16px' }}>{row.recipient_trade_name}</TableCell>
        <TableCell style={{ padding: '8px 16px' }}>{row.recipient_address_one}</TableCell>
        <TableCell style={{ padding: '8px 16px' }}>{row.recipient_address_two}</TableCell>
        <TableCell style={{ padding: '8px 16px' }}>{row.recipient_location}</TableCell>
        <TableCell style={{ padding: '8px 16px' }}>{row.recipient_state}</TableCell>
        <TableCell style={{ padding: '8px 16px' }}>{row.recipient_pincode}</TableCell>
        <TableCell style={{ padding: '8px 16px' }}>{row.recipient_email}</TableCell>
        <TableCell style={{ padding: '8px 16px' }}>{row.recipient_phone}</TableCell>
        <TableCell style={{ padding: '8px 16px' }}>
          <EditIcon style={{ cursor: 'pointer' }} 
           sx={{
            '&:hover': {
              color: 'blue',  // Change to your desired hover color
            },
          }}
          onClick={() => handleEdit(row)} />
          <AddIcon
    style={{ cursor: 'pointer' }}  
    sx={{
      '&:hover': {
        color: 'green',  
      },
    }}
    onClick={() => handleAdd(row.id)}  
  />
        </TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={11}>No data found!</TableCell>
    </TableRow>
  )}
</TableBody>

  </Table>
</div>
<Dialog open={isDialogOpenline} onClose={handlelineClose}  fullWidth maxWidth="md">
      <DialogTitle>Add Address Information</DialogTitle>
      <DialogContent >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="GSTIN"
              margin="dense"
              name="gstin"
              disabled
              value={formData.gstin}
                InputLabelProps={{ shrink: true }}
              // onChange={handlelineInputChange}
              // error={validationErrors.includes('gstin')}
              // helperText={validationErrors.includes('gstin') ? 'This field is required' : ''}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Location"
              margin="dense"
              name="location"
              value={formData.location}
              onChange={handlelineInputChange}
              error={validationErrors.includes('location')}
              helperText={validationErrors.includes('location') ? 'This field is required' : ''}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Pincode"
             margin="dense"
              name="pincode"
              value={formData.pincode}
              inputProps={{
                maxLength: 6, 
              }}
              onChange={handlelineInputChange}
              error={validationErrors.includes('pincode')}
              helperText={validationErrors.includes('pincode') ? 'This field is required' : ''}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Address 1"
              name="address1"
              value={formData.address1}
              onChange={handlelineInputChange}
              error={validationErrors.includes('address1')}
              helperText={validationErrors.includes('address1') ? 'This field is required' : ''}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Address 2"
              name="address2"
              value={formData.address2}
              onChange={handlelineInputChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <TextField
            InputLabelProps={{ shrink: true }}
    fullWidth
    select
    label="State"
    name="state"
    value={formData.state || ''} 
    onChange={handlelineInputChange}
    error={validationErrors.includes("state")}
    helperText={
      validationErrors.includes("state") ? "This field is required" : ""
    }
  >
    {stateschild.map((state, index) => (
      <MenuItem key={index} value={state.name}>
        {state.name}
      </MenuItem>
    ))}
  </TextField>
          </Grid>
        </Grid>

        <Grid container spacing={2} justifyContent="flex-end" style={{ marginTop: '16px' }}>
          <Grid item>
            <Button variant="contained" color="primary" onClick={() => handleSubmitline(currentRowId)}>
            {isEditMode ? 'Update' : 'Submit'}
            </Button>
          </Grid>
          <Grid item>
            <Button variant="outlined" color="secondary" onClick={handlelineClose}>
              Cancel
            </Button>
          </Grid>
        </Grid>
        <Box sx={{ maxHeight: '370px', overflowY: 'auto', marginTop: '20px' }}>
  <Table stickyHeader sx={{ tableLayout: 'auto' }}>
    <TableHead>
      <TableRow>
        <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>Address One</TableCell>
        <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>Address Two</TableCell>
        <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>Location</TableCell>
        <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>State</TableCell>
        <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>Pin Code</TableCell>
        <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>Action</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {supplierChildData.length > 0 ? (
        supplierChildData.map((row) => (
          <TableRow key={row.id}>
            <TableCell>{row.recipient_detail_address_one}</TableCell>
            <TableCell>{row.recipient_detail_address_two}</TableCell>
            <TableCell>{row.recipient_detail_location}</TableCell>
            <TableCell>{row.recipient_detail_state}</TableCell>
            <TableCell>{row.recipient_detail_pincode}</TableCell>
            <TableCell style={{ padding: '8px 16px' }}>
          <EditIcon style={{ cursor: 'pointer' }} 
           sx={{
            '&:hover': {
              color: 'blue', 
            },
          }}
          onClick={() => handleEditline(row)}
           />
          </TableCell>
            
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={5} align="center">
            No data available
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>
</Box>
      </DialogContent>
    </Dialog>
            

  
  

    </BoxWrapper>
    <TablePagination
      
        rowsPerPageOptions={[25, 50, 100,1000,3000]}
        component="div"
        count={rowCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, newPage) => {
          setPage(newPage);
          refresh(newPage, rowsPerPage, searchTerm); 
        }}
        onRowsPerPageChange={(event) => {
          const newRowsPerPage = parseInt(event.target.value, 10);
          setRowsPerPage(newRowsPerPage);
          setPage(0); 
          refresh(0, newRowsPerPage, searchTerm);
        }}
      />
   
    </div>
  );
}

export default CreateMaster;
